import { render, staticRenderFns } from "./HighlightReelTab.vue?vue&type=template&id=48215d92&scoped=true"
import script from "./HighlightReelTab.vue?vue&type=script&lang=js"
export * from "./HighlightReelTab.vue?vue&type=script&lang=js"
import style0 from "./HighlightReelTab.vue?vue&type=style&index=0&id=48215d92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48215d92",
  null
  
)

export default component.exports